import React from 'react';

const ndaItems = [
  { title: 'Definitie vertrouwelijke informatie naar Belgisch recht', desc: 'Exacte omschrijving conform de Belgische wetgeving inzake bedrijfsgeheimen (Wet van 30 juli 2018)' },
  { title: 'Geheimhoudingsplicht voor zelfstandigen', desc: 'Verplichtingen van de ontvanger om informatie niet te delen met derden, afgestemd op de Belgische context' },
  { title: 'Uitzonderingen op de geheimhouding', desc: 'Situaties waarbij de geheimhoudingsplicht niet van toepassing is, zoals wettelijke verplichtingen' },
  { title: 'Duur van de NDA in België', desc: 'Hoe lang de geheimhoudingsplicht van kracht blijft — typisch 2 tot 5 jaar naar Belgisch recht' },
  { title: 'Boeteclausule en schadevergoeding', desc: 'Financiële gevolgen bij schending, inclusief forfaitaire boete en aanvullende schadevergoeding' },
  { title: 'Teruggave van vertrouwelijke documenten', desc: 'Verplichting om alle ontvangen documenten en kopieën terug te geven na afloop van de opdracht' },
  { title: 'Toepasselijk Belgisch recht', desc: 'Belgisch recht als toepasselijk recht en bevoegde Belgische rechtbank bij geschillen' },
  { title: 'Ondernemingsnummer en btw-nummer identificatie', desc: 'Correcte identificatie van partijen met ondernemingsnummer (KBO) en btw-nummer voor Belgische zelfstandigen' },
];

const NdaBelgiumContent = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Wat bevat een Belgische NDA voor freelancers?</h2>
    <p className="text-gray-700 mb-6 leading-relaxed">
      Een professionele NDA voor Belgische zelfstandigen en freelancers bevat alle juridisch vereiste elementen conform het Belgisch recht. Hieronder vind je de 8 kernonderdelen van een goede Belgische geheimhoudingsovereenkomst:
    </p>
    <ul className="space-y-3">
      {ndaItems?.map((item, i) => (
        <li key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
          <span className="flex-shrink-0 w-6 h-6 bg-[#FF8C00] rounded-full flex items-center justify-center mt-0.5">
            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </span>
          <div>
            <span className="font-semibold text-[#2F4E6F]">{item?.title}:</span>{' '}
            <span className="text-gray-600">{item?.desc}</span>
          </div>
        </li>
      ))}
    </ul>
  </section>
);

export default NdaBelgiumContent;
